import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import '../styles/Form.css';
import '../styles/Notifications.css';

const Contacto = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    apellido: '',
    empresa: '',
    telefono: '',
    email: '',
    motivo: '',
    mensaje: '',
    aceptaPolitica: false,
  });

  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === 'checkbox') {
      setFormData({
        ...formData,
        [name]: checked,
      });
    }
    else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(false);

    if (!formData.aceptaPolitica) {
      setError('Debes aceptar la política de tratamiento de datos.');
      setTimeout(() => setError(null), 3000);
      return;
    }

    const templateParams = {
      nombre: formData.nombre,
      apellido: formData.apellido,
      empresa: formData.empresa || "No especificado",
      telefono: formData.telefono || "No especificado",
      email: formData.email,
      motivo: formData.motivo,
      mensaje: formData.mensaje,
    };

    emailjs
      .send('service_hbxq0xd', 'template_1ql31px', templateParams, 'DrbmVpjAvwWZ7Ntms')
      .then(
        (response) => {
          console.log('SUCCESS!', response.status, response.text);
          setSuccess(true);
          setFormData({
            nombre: '',
            apellido: '',
            empresa: '',
            telefono: '',
            email: '',
            motivo: '',
            mensaje: '',
            aceptaPolitica: false,
          }); // Limpiar el formulario

          setTimeout(() => setSuccess(false), 3000); // Ocultar mensaje de éxito tras 3 segundos

        },
        (err) => {
          console.error('FAILED...contacto', err);
          setError("Hubo un error al enviar el mensaje. Inténtalo de nuevo más tarde.");
          setTimeout(() => setError(null), 3000); // Ocultar mensaje de error tras 3 segundos
        }
      );
  };

  return (
    <div className="form-container">
      {/* Mostrar notificaciones de error o éxito */}
      {error && <p className="notification error">{error}</p>}
      {success && <p className="notification success">¡Mensaje enviado exitosamente!</p>}

      <form onSubmit={handleSubmit} className="cuerpo-form">
        <div className="form-group">
          <div className="form-group-item">
            <label className="form-label">Nombre *</label>
            <input type="text" name="nombre" value={formData.nombre} onChange={handleChange} required />
          </div>
          <div className="form-group-item">
            <label className="form-label">Apellido *</label>
            <input type="text" name="apellido" value={formData.apellido} onChange={handleChange} required />
          </div>
        </div>

        <div className="form-group">
          <div className="form-group-item">
            <label className="form-label">Empresa (si procede)</label>
            <input type="text" name="empresa" value={formData.empresa} onChange={handleChange} />
          </div>
          <div className="form-group-item">
            <label className="form-label">Teléfono</label>
            <input type="text" name="telefono" value={formData.telefono} onChange={handleChange} />
          </div>
        </div>

        <div className="form-group">
          <div className="form-group-item">
            <label className="form-label">Email *</label>
            <input type="email" name="email" value={formData.email} onChange={handleChange} required />
          </div>
          <div className="form-group-item">
            <label className="form-label">Motivo de su consulta *</label>
            <select name="motivo" value={formData.motivo} onChange={handleChange} required>
              <option value="">Escoge una opción ...</option>
              <option value="Alayi Box 📦">Alayi Box 📦</option>
              <option value="Alayi Travels ✈">Alayi Travels ✈</option>
              <option value="Alayi Events 🎉">Alayi Events 🎉​</option>
              <option value="Entradas 🎟️">Entradas 🎟️​</option>
            </select>
          </div>
        </div>

        <div className="form-group-full">
          <label className="form-label">Mensaje *</label>
          <textarea name="mensaje" rows="5" value={formData.mensaje} onChange={handleChange} required></textarea>
        </div>

        <button className="button-gold">Enviar mensaje</button>

        {/* Checkbox para aceptar la política de datos */}
        <p className="privacy-note">
          <label>
            <input
              type="checkbox"
              name="aceptaPolitica"
              checked={formData.aceptaPolitica}
              onChange={handleChange}
              required
            />
            Acepto la{' '}
            <strong>
              <a href="/politica-datos" target="_blank" rel="noopener noreferrer">
                política de tratamiento de datos personales
              </a>
            </strong>
          </label>
        </p>
      </form>
    </div>
  );
};

export default Contacto;